<template>
    <Header>
        <template v-slot:title>
            <h1 v-if="workflow.plugins_active">
                <span v-if="! editing_title">{{ workflow.title ? workflow.title : 'New Workflow' }}</span>
                <input type="text"
                       v-if="editing_title"
                       v-model="workflow.title"
                       @blur="editTitle(false)"
                       @keyup.enter="editTitle(false)"
                       id="workflow-title"
                       class="opui-form-control"
                       required
                />
                <a href="#" @click.prevent="editTitle(true)" v-if="! editing_title" class="opui-pl-2"><i class="opui-fa opui-fa-pencil"></i></a>
            </h1>
        </template>

        <template v-slot:right-menu-buttons v-if="workflow.plugins_active">
            <Toggle v-model="workflow.active" v-if="loaded && workflow.id && hasTrigger && workflow.triggers[0].event !== 'trigger/new'" @change="toggleStatus" />
        </template>
    </Header>
    <div>
        <main class="opui-main opui-pt-7" v-if="loaded">
            <div class="opui-container opui-max-900" v-if="workflow.plugins_active">
                <div class="opui-flow-list opui-item-list">
                    <ul v-if="workflow.items.length || hasTrigger">
                        <li v-if="workflow.triggers.length" class="opfl-trigger-item" v-for="(trigger, index) in workflow.triggers" :key="trigger.id">
                            <ItemTrigger v-if="trigger.event !== 'trigger/new'" :workflow="workflow" :trigger="trigger" @click.prevent="editTrigger(trigger)" />

                            <div v-else class="opui-item op-flow-type-trigger" @click.prevent="editTrigger(trigger)" :workflow="workflow">
                                <div class="opui-left">
                                    <a href="#" class="op-flow-icon">
                                        <i class="opui-fa opui-fa-plus-square-o"></i>
                                    </a>
                                    <div class="opui-title">
                                        <p><a href="#">{{ $e('Click to add new trigger') }}</a></p>
                                        <h3><a href="#">{{ $e('Add new trigger to start workflow') }}</a></h3>
                                    </div>
                                </div>
                            </div>

                            <div class="op-flow-connector" v-if="trigger.event !== 'trigger/new'">
                                <a href="#" @click.prevent="addItem(0)" class="opui-flow-connector-add"></a>
                            </div>
                        </li>

                        <li v-for="(item, index) in workflow.items" :key="item.id" :class="'opfl-'+item.type+'-item'">
                            <ItemAction :workflow="workflow" :item="item" @edit="editItem" @delete="deleteItem" v-if="item.type === 'action'" />
                            <ItemDelay  :workflow="workflow" :item="item" @edit="editItem" @delete="deleteItem" v-if="item.type === 'delay'" />
                            <ItemFilter :workflow="workflow" :item="item" @edit="editItem" @delete="deleteItem" v-if="item.type === 'filter'" />

                            <div class="op-flow-connector">
                                <a href="#" @click.prevent="addItem(item.order_id)" class="opui-flow-connector-add"></a>
                            </div>
                        </li>
                    </ul>
                </div>

                <div class="opui-text-center" v-if="! hasTrigger && loaded && workflow.id">
                    <div class="opui-flow-list opui-item-list">
                        <ul>
                            <li class="opfl-trigger-item" @click.prevent="addTrigger">
                                <div class="opui-item op-flow-type-trigger">
                                    <div class="opui-left">
                                        <a href="#" class="op-flow-icon">
                                            <i class="opui-fa opui-fa-plus-square-o"></i>
                                        </a>
                                        <div class="opui-title">
                                            <p><a href="#">{{ $e('Click to add new trigger') }}</a></p>
                                            <h3><a href="#">{{ $e('Add new trigger to start workflow') }}</a></h3>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div v-else>
                <div class="opui-container opui-max-900">
                    <div class="opui-alert opui-alert-dismissible opui-alert-danger">
                        <button type="button" class="opui-close" data-bs-dismiss="alert"></button>
                        <strong>{{ $e('Invalid Workflow') }}</strong>
                        <p>{{ $e('This workflow contains items from plugins that are not currently activated.') }}</p>
                    </div>
                </div>
            </div>
            <!---<h4>Triggers</h4> -->
            <!-- <p><small><pre>{{ workflow.triggers }}</pre></small></p> -->
            <!-- <h4>New Trigger</h4>
            <p><small><pre>{{ newTrigger }}</pre></small></p>-->
            <!-- <h4>Items</h4>-->
            <!-- <p><small><pre>{{ workflow.items }}</pre></small></p>-->
        </main>

        <main v-if="! loaded || ! workflow.id" class="opui-main opui-pt-7">
            <WorkflowIsLoading :itemRows="loadingRows" />
        </main>
    </div>
</template>

<script>
import ConfirmModal from "../components/Global/ConfirmModal.vue"
import Header       from "../components/Global/Header.vue"
import ItemModal    from "../components/Workflows/Modals/ItemModal.vue"
import SearchInput  from "../components/Global/SearchInput.vue"
import TriggerModal from "../components/Workflows/Modals/TriggerModal.vue"
import Toggle       from "../components/Global/Toggle.vue"
import ItemAction from "../components/Workflows/ItemAction.vue"
import ItemDelay from "../components/Workflows/ItemDelay.vue"
import ItemFilter from "../components/Workflows/ItemFilter.vue"
import ItemTrigger from "../components/Workflows/ItemTrigger.vue"
import WorkflowIsLoading from "../components/Loading/WorkflowIsLoading.vue"

export default {
    components: { ItemTrigger, ItemFilter, ItemDelay, ItemAction, Header, ItemModal, SearchInput, TriggerModal, Toggle, WorkflowIsLoading },
    data() {
        return {
            loaded: false,
            action: 'create',
            saving: false,
            isDirty: false,
            workflow: {
                title:    'New Workflow',
                items:    [],
                triggers: [],
                active:   false,
            },
            newTrigger: {
                event:       null,
                text:        null,
                description: null,
                settings:    {
                    "post_type":      "page", "post_type_title":   "Pages",
                    "page_id":        "all",  "page_title":        "- All -",
                    "form_id":        "all",  "form_title":        "- All -",
                    "membership_id":  "all",  "membership_title":  "- All -",
                    "funnel_id":      "all",  "funnel_title":      "- All -",
                    "funnel_step_id": "all",  "funnel_step_title": "- All -",
                },
            },
            item: {
                action:      null,
                text:        null,
                description: null,
                settings:    {},
            },
            editing_title: false,

            testSimpleOptions: [
                { text: 'Option 1', id: 1 },
                { text: 'Option 2', id: 2 },
                { text: 'Option 3', id: 3 },
                { text: 'Option 4', id: 4 },
                { text: 'Option 5', id: 5 },
            ],

            triggerKey: 1,
        }
    },
    async created() {
        this.$events.on('firstTriggerOpened', this.save)

        // Only load when editing existing workflow
        if (this.$route.params.id) {
            this.workflow.id = this.$route.params.id
            await this.loadInitialData()
        } else {
            let save = await this.save(false)
            this.loaded = true
        }

        // this.$events.on('itemAdded',       this.reorderItems)
        // this.$events.on('workflowUpdated', this.workflowUpdated)
    },
    computed: {
        /**
         * Number of rows for loading skeleton
         */
        loadingRows() {
            return 3
        },

        /**
         * Check if workflow has any triggers
         */
        hasTrigger() {
            return this.workflow &&
                this.workflow.triggers &&
                this.workflow.triggers.length > 0 &&
                this.workflow.triggers[0].event
        },

        /**
         * Check if workflow has any items
         */
        hasAction() {
            return this.workflow.items && this.workflow.items.length > 0
        },
    },
    methods: {
        async loadInitialData() {
            let response = await this.$http.get('workflows/' + this.workflow.id)
            let status = await response.status

            if (status === 200) {
                this.workflow = await response.data.data
            } else {
                console.info('Error when fetching workflow.', response.data)
            }

            if (this.loaded) {
                // this.$toast.success("Workflow loaded")
            }

            this.loaded = true
        },

        /**
         * Toggle status of workflow
         * @returns {Promise<void>}
         */
        async toggleStatus() {
            let response = await this.$http.post('workflows/' + this.workflow.id + '/status', { 'active': this.workflow.active })
            let status   = await response.status

            if (status === 200) {
                this.$toast.success('Saved.')
                this.$emit('statusToggled')
            } else {
                console.info('Error when updating workflow status.', response.data)
            }
        },

        /**
         * Reorder all items (after adding new ones)
         * TODO: Maybe remove this, since we're reloading the flow anyway
         */
        reorderItems(item) {
            let orderId = 10

            // Order the items
            this.workflow.items.sort((a, b) => a.order_id - b.order_id)

            // And update order IDs
            this.workflow.items.map((item) => {
                item.order_id = orderId
                orderId += 10
            })
        },

        /**
         * Save the current workflow (with all items)
         */
        async save(showNotification = true) {
            if (! this.saving) {
                this.saving = true
                let url      = this.workflow.id ? 'workflows/' + this.workflow.id : 'workflows';
                let response = await this.$http.post(url, this.workflow)
                let status   = await response.status

                if (status === 200) {
                    this.workflow = await response.data.data
                    this.$router.push('/workflows/' + this.workflow.id);
                    if (showNotification) this.$toast.success("Workflow saved")
                } else {
                    console.info('Error when saving workflow.', response.data)
                }

                this.saving = false
                this.workflow.deleteIds = [] // Clear out IDs for deleting
                await this.loadInitialData()
            }
        },

        /**
         * Show the title editor
         * @param mode
         */
        editTitle(mode) {
            this.editing_title = mode

            // Show the editor
            if (mode) {
                setTimeout(() => {
                    document.getElementById('workflow-title').focus()
                }, 50);

            // Save title on blur
            } else {
                this.save()
            }
        },

        /**
         * Add new workflow item
         */
        async addTrigger() {
            // Add new trigger to the list
            let trigger = JSON.parse(JSON.stringify(this.newTrigger))
            trigger.id = 'new.' + Math.floor(Date.now() / 1000)
            this.workflow.triggers = [trigger]

            setTimeout(() => {
                this.$vfm.show({ component: TriggerModal, bind: {
                        workflow: this.workflow,
                    }, on: { updated: this.workflowUpdated, beforeClose: () => this.$events.emit('triggerModalClosed') } })
            }, 50)
        },

        /**
         * Add new workflow item
         */
        addItem(afterOrder) {
            // Reset the item
            this.item.type = null

            // Show the modal
            this.$vfm.show({ component: ItemModal, bind: {
                workflow:   this.workflow,
                item:       this.item,
                afterOrder: afterOrder,
            }, on: { updated: this.workflowUpdated } })
        },

        /**
         * Add new workflow item
         */
        editTrigger(trigger) {
            this.$vfm.show({ component: TriggerModal, bind: {
                workflow: this.workflow,
                trigger:  trigger
            }, on: { updated: this.workflowUpdated, beforeClose: () => this.$events.emit('triggerModalClosed') } })
        },

        /**
         * Add new workflow item
         */
        editItem(item) {
            this.$vfm.show({ component: ItemModal, bind: {
                workflow: this.workflow,
                item:     item
            }, on: { updated: this.workflowUpdated } })
        },

        /**
         * Delete item from the list
         */
        deleteItem(item) {
            let that = this

            this.$vfm.show({
                component: ConfirmModal,
                bind: { title: 'Delete Item', text: 'Are you sure you want to delete this workflow item?' },
                on: {
                    confirm(close) {
                        that.workflow.items = that.workflow.items.filter((value, index, arr) => {
                            return value.id !== item.id
                        })

                        // Set item to delete
                        that.workflow.deleteIds = [item.id]

                        // Save the changes
                        that.save()
                        close()
                    },
                    cancel(close) {
                        close()
                    }
                }
            })
        },

        /**
         * Triggered when we update items
         * For now we just re-save the workflow
         */
        workflowUpdated(workflow) {
            if (workflow) {
                this.workflow.triggers[0] = workflow.triggers[0]
            }

            this.reorderItems()
            this.save()
        },
    }
}
</script>

<style scoped>
#workflow-title {
    margin-top: 11px;
    margin-bottom: 12px;
}
</style>
